var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 142,
    height: 38,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "m16.67 18.802-5.432 9.41-2.342 4.05L0 27.124l4.816-8.34L0 10.443l8.899-5.127 2.235 3.86 5.534 9.586q0 .02.003.04z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M45.19 18.786a18.78 18.78 0 0 1-18.784 18.781H12.054l1.472-2.54 3.88-6.726h9a9.518 9.518 0 1 0 0-19.033h-9.103l-3.777-6.541L11.953 0h14.453A18.784 18.784 0 0 1 45.19 18.786"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60 11h6.242c5.226 0 8.532 2.912 8.532 7.559 0 4.646-3.283 7.47-8.532 7.47H60zm6.242 12.242c3.352 0 5.458-1.827 5.458-4.72 0-2.894-2.129-4.74-5.458-4.74h-3.353v9.46zM78.59 11h14.27v2.782H81.484v3.098h10.128v2.782H81.484v3.539l11.376.023v2.782H78.59zm18.893 0h14.269v2.782h-11.375v3.098h10.127v2.782h-10.127v3.539l11.375.023v2.782h-14.27zm17.371 15.386h10.243v2.783h-10.243zm17.733-7.966L127.11 11h3.812l3.492 4.74L137.72 11h3.816l-5.365 7.123L142 26.006h-3.816l-3.863-5.25-3.654 5.25h-3.812z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0,
    x2: 16.671,
    y1: 18.784,
    y2: 18.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffaf26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f85d31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 11.953,
    x2: 45.19,
    y1: 18.784,
    y2: 18.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0eb4e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b75c2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2633a5e70faaf453953aa3b1cac18679.svg";
export { ForwardRef as ReactComponent };